export default "__VITE_ASSET__C$wKH6Ot__"